import { useMutation } from "@tanstack/react-query";
import { postDetectionDetailDownload } from "../api/detect";

const usePostDetectionDetailDownload = () => {
  const mutation = useMutation({
    mutationFn: postDetectionDetailDownload,
  });
  return mutation;
};

export default usePostDetectionDetailDownload;
